export default {
  nav: {
    home: 'Home',
    categories: 'Categories',
    guide: 'Guide',
    review: 'Review',
    shipping: 'Shipping',
    safety: 'Safety',
    faq: 'FAQ',
    cta: 'Visit Main Site',
    shoppingGuide: 'Shopping Guide',
  },
  hero: {
    badge: 'Updated for 2026 · Independent Resource',
    title: 'AllChinaBuy Spreadsheet — Find Products, Links & QC Picks Faster',
    subtitle:
      'Explore the latest AllChinaBuy spreadsheet resources, product finds, useful links, QC information, buying guides and shipping resources in one organized place.',
    ctaPrimary: 'AllChinaBuy Spreadsheet',
    ctaSecondary: 'Buy It Now',
    searchPlaceholder: 'Search products, categories or guides...',
  },
  categories: {
    title: 'Popular Categories',
    subtitle: 'Jump straight to the products and links you need on the main spreadsheet.',
    dropdownLabel: 'Browse by category',
    dropdownPlaceholder: 'Select a category',
    visit: 'View on main site',
  },
  cat: {
    shoes: 'Shoes',
    hoodies: 'Hoodies / Sweaters',
    tshirts: 'T-Shirts',
    jackets: 'Jackets',
    pants: 'Pants / Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear / Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    other: 'Other Stuff',
  },
  info: {
    sectionTitle: 'Everything About the AllChinaBuy Spreadsheet',
    whatTitle: 'What is the AllChinaBuy Spreadsheet?',
    whatBody:
      'The AllChinaBuy spreadsheet is a curated collection of product finds, working links, QC photos and shipping notes gathered into one organized sheet. Instead of digging through endless threads, buyers open a single spreadsheet to see items across shoes, hoodies, t-shirts, jackets, bags and more — each row showing the product, its link, price range and quality-control status.',
    howTitle: 'How It Works',
    howBody:
      'Open the spreadsheet, pick a category from the dropdown or the grid, and jump to the item you want. Each product links directly to the main store so you can check details, compare options and place an order in a few clicks. The layout is built for speed: find the item, check the QC photo, copy the link, done.',
    reviewTitle: 'Why Buyers Love It',
    reviewBody:
      'Users keep coming back to the spreadsheet because it saves hours of searching and removes the guesswork. The most useful version combines real buyer feedback with up-to-date QC photos, so you know what you are getting before you pay. It is a research tool, not a shop — final purchases happen on the main site.',
    shippingTitle: 'Shipping Cost & Warehouse',
    shippingBody:
      'Shipping cost depends on the item, its weight and the shipping line you choose. The spreadsheet groups items by category so you can compare similar products and plan a combined order to lower shipping per item. Check the warehouse and shipping sections for current methods and cost-saving tips.',
    qcTitle: 'QC & Product Inspection',
    qcBody:
      'Quality control is the step that protects your order. Look for spreadsheets that include QC photos, measurements and seller notes before you commit. If a listing has no QC data, treat it with caution and ask the seller for photos first.',
    safetyTitle: 'Safety Center',
    safetyBody:
      'This is an independent informational resource and is not affiliated with or operated by AllChinaBuy. Watch out for fake spreadsheets and phishing links. Only use links that come from the main site, and never enter your login or payment details on unfamiliar pages.',
  },
  article: {
    badge: 'Complete Guide',
    title: 'AllChinaBuy Spreadsheet: Complete Guide to Finds, Links & QC',
    desc:
      'A full walkthrough of what the AllChinaBuy spreadsheet is, what is inside it, how to use it and how to check products safely before you order.',
    cta: 'Read the Full Guide',
    readTime: '8 min read',
    updated: 'Last updated',
  },
  faq: {
    title: 'Frequently Asked Questions',
    q1: 'Is the AllChinaBuy Spreadsheet free to use?',
    a1: 'The spreadsheet is a free informational resource. You can browse categories and links here, and final purchases happen on the main site.',
    q2: 'Is this site affiliated with AllChinaBuy?',
    a2: 'No. This is an independent informational resource. We are not affiliated with or operated by AllChinaBuy.',
    q3: 'How do I check the QC of a product?',
    a3: 'Look for QC photos, measurements and seller notes in the listing. If a product has no QC data, ask the seller for photos before ordering.',
    q4: 'How do I reduce shipping costs?',
    a4: 'Group several items into one order, choose a suitable shipping line and compare similar products in the same category before you commit.',
    q5: 'Are the product links safe?',
    a5: 'Only use links that come from the main site. Avoid third-party or shortened links, and never enter login or payment details on unfamiliar pages.',
  },
  footer: {
    about:
      'An independent informational resource for AllChinaBuy spreadsheet finds, links, QC photos and shipping guides. We are not affiliated with or operated by AllChinaBuy.',
    linksTitle: 'Quick Links',
    categoriesTitle: 'Categories',
    disclaimer:
      'This is an independent informational resource and is not affiliated with or operated by AllChinaBuy.',
    rights: 'All rights reserved.',
  },
  pillar: {
    title: 'Pillar Guides & Deep Dives',
    subtitle: 'Original, in-depth guides to help you buy smarter and safer with the AllChinaBuy spreadsheet.',
    read: 'Read guide',
  },
  guide: {
    notFound: 'Guide not found',
    notFoundDesc: 'The guide you are looking for does not exist. Head back to the homepage to browse all guides.',
    ctaTitle: 'Ready to browse the latest finds?',
    ctaDesc: 'Explore every category and jump straight to the products on the main website.',
    related: 'Related guides',
  },
  common: {
    explore: 'Explore',
    learnMore: 'Learn more',
    backHome: 'Back to home',
    readArticle: 'Read the guide',
  },
};